import { ButtonProps, Tooltip } from "@chakra-ui/react";
import React from "react";
import { BILLING_OWNER_REQUIRED_MESSAGE } from "../../components/organisms/taxReport/ActionOrPurchaseButton";
import { canUnlockPlanFeature } from "../../helper/canUnlockPlanFeature";
import { PlanAccount } from "./PlanAccount";
import { UnlockButton } from "./UnlockButton";

export function UnlockPlanButton({
  planName,
  account,
  onClick,
  isDisabled,
  ...props
}: {
  planName: string;
  account: PlanAccount;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
} & Omit<ButtonProps, "children">) {
  const canUnlock = canUnlockPlanFeature(account);

  return (
    <Tooltip
      shouldWrapChildren
      label={!canUnlock ? BILLING_OWNER_REQUIRED_MESSAGE : undefined}
    >
      <UnlockButton
        onClick={onClick}
        data-event={`purchase-start-${planName}`}
        isDisabled={!canUnlock || isDisabled}
        {...props}
      >{`Buy ${planName}`}</UnlockButton>
    </Tooltip>
  );
}
